/**
 * Mobile Lash/Nail drawer menu.
 * Drives the same <html data-cs-active> / localStorage "nina-vertical" memory
 * the split hero uses, so the drawer, the homepage swap, and the persisted
 * choice all stay in sync. CSS handles which tab is active and which menu list
 * shows, based on data-cs-active.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "nina-vertical";

  function read() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }
  function write(v) {
    try {
      window.localStorage.setItem(STORAGE_KEY, v);
    } catch (e) {}
  }

  function setActive(key) {
    if (key !== "lash" && key !== "nail") return;
    document.documentElement.setAttribute("data-cs-active", key);
    write(key);
    // The swap is CSS-driven (data-cs-active). We deliberately don't dispatch
    // global resize events here — the mobile carousels are CSS scroll (no
    // re-measure needed), and firing theme:resize:width would reset unrelated
    // components like the top marquee.
  }

  // If nothing set the active world yet (non-homepage pages), use the stored
  // choice, defaulting to lash.
  if (!document.documentElement.hasAttribute("data-cs-active")) {
    var stored = read();
    document.documentElement.setAttribute(
      "data-cs-active",
      stored === "nail" || stored === "lash" ? stored : "lash"
    );
  }

  document.querySelectorAll("[data-vmenu] .vmenu__tab").forEach(function (tab) {
    tab.addEventListener("click", function () {
      setActive(tab.getAttribute("data-vmenu-key"));
    });
  });
})();
